module.exports = __webpack_public_path__ + "img/seejc_vizual1.d842de6e.jpg";